import { shouldSwapDimensions } from '@v2/components/imageHandling/helpers';
import { useGetImageUri } from '@v2/components/imageHandling/hooks/useGetImageUri';
import { ProgressiveImageTabletMobileProps } from '@v2/components/imageHandling/components/ProgressiveImage/ProgressiveImageTabletMobile';

interface UseManageImageParams extends Required<Pick<ProgressiveImageTabletMobileProps, 'image' | 'width' | 'height'>> {}

export const useManageImage = ({ image, width, height }: UseManageImageParams) => {
  const { getHighResUri, getLowResUri } = useGetImageUri();
  const lowResUri = getLowResUri(image);
  const highResUri = getHighResUri(image);
  const croppedImageURI = image.croppedImageUri;
  const angle = image.customRotate?.[image.pageNumber] ?? 0;
  const swapDimensions = shouldSwapDimensions(angle);
  const imageWidth = swapDimensions ? height : width;
  const imageHeight = swapDimensions ? width : height;

  const shouldDisplayCroppedImagePreview = image.isCropped && croppedImageURI && image.isProcessing;

  const shouldDisplayPreviewBase64 = ((!lowResUri && !highResUri) || image?.isProcessing) && image?.base64;

  return {
    lowResUri,
    highResUri,
    angle,
    swapDimensions,
    imageWidth,
    imageHeight,
    shouldDisplayPreviewBase64,
    shouldDisplayCroppedImagePreview,
    croppedImageURI,
  };
};
